var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 59,
    fill: "#F0AB2E",
    fillOpacity: 0.3,
    stroke: "#F0AB2E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 60C40 48.9717 48.9717 40 60 40C71.0283 40 80 48.9717 80 60C80 71.0283 71.0283 80 60 80C48.9717 80 40 71.0283 40 60ZM43.3333 60C43.3333 69.19 50.81 76.6667 60 76.6667C69.19 76.6667 76.6667 69.19 76.6667 60C76.6667 50.81 69.19 43.3333 60 43.3333C50.81 43.3333 43.3333 50.81 43.3333 60ZM59.0542 62.5308L66.2192 53.9333C66.8084 53.2258 67.86 53.1308 68.5675 53.7192C69.2742 54.3092 69.37 55.3592 68.7809 56.0667L60.4475 66.0667C60.1475 66.4267 59.71 66.6442 59.2425 66.665C59.2175 66.6667 59.1917 66.6667 59.1667 66.6667C58.7258 66.6667 58.3017 66.4917 57.9875 66.1783L52.9875 61.1783C52.3367 60.5275 52.3367 59.4725 52.9875 58.8217C53.6375 58.1708 54.6942 58.1708 55.3442 58.8217L59.0542 62.5308Z",
    fill: "#F0AB2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.63b472e4.svg";
export { ForwardRef as ReactComponent };